import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class QueryStringSerializationService {
    private get SEPARATOR_PROPERTY(): string {
        return ".";
    }

    public serialize(data: any): string {
        return this.doSerialize(data);
    }

    private doSerialize(data: any, prefix: string = ""): string {
        if (!Object.keys(data).length) {
            return "";
        }

        const members = [];

        let property;
        for (property in data) {
            if (data.hasOwnProperty(property)) {
                const key = prefix ? `${prefix}${property}` : property;
                const value = data[property];
                members.push((value !== null && typeof value === "object") ?
                    this.doSerialize(value, `${key}${this.SEPARATOR_PROPERTY}`) :
                    encodeURIComponent(key) + "=" + encodeURIComponent(value));
            }
        }

        return members
            .filter(s => s.split("=")[1]) // skip empty values
            .join("&");
    }

    public deserialize<TResult>(queryString: string): TResult {
        try {
            const data = {};
            for (const queryParam of queryString.split("&")) {
                const kvp = decodeURIComponent(queryParam).split("=");
                const path = kvp[0].split(this.SEPARATOR_PROPERTY);
                const value = kvp[1];

                // process only non-empty values
                if (value) {
                    this.assignProperty(data, path, value);
                }
            }

            return data as TResult;
        } catch (error) {
            return {} as TResult;
        }
    }

    private assignProperty(data: any, propertyPath: Array<string>, value: string): void {
        if (!propertyPath.length) {
            return;
        }

        const isPlainProperty = propertyPath.length === 1;
        const propertyAlias = propertyPath[0];

        if (isPlainProperty) {
            data[propertyAlias] = value;
        } else { // nested property
            let nested: any = null;

            if (data.hasOwnProperty(propertyAlias)) {
                nested = data[propertyAlias];
            } else {
                const isArray = !isNaN(parseInt(propertyPath[1], 10)); // the case is "..&collection.0=value&..."
                nested = isArray ? [] : {};
                data[propertyAlias] = nested;
            }

            const nextPath = propertyPath.slice(1);

            this.assignProperty(nested, nextPath, value);
        }
    }
}
